import type { PositionData } from '@ori/analytics-data';

type EventName = typeof Name;

export const Name = 'open-product-info-dialog';

export const OpenProductInfoDialogDialog: EventName = Name;

export enum DialogMode {
  Favorites = 'favorites',
  Loading = 'loading',
  RewardsShop = 'rewardsShop',
  StandardBuy = 'standardBuy',
}

interface ReplaceSubscriptionData {
  droppingId: number;
  subscriptionId: number;
}

export interface Data extends PositionData {
  atpClusterId?: number;
  initialProductCode?: string;
  lineNumber?: number;
  mode: DialogMode;
  originalItemCode?: string;
  originalQuantity?: number;
  productCodes: string[];
  replaceSubscription?: ReplaceSubscriptionData;
}

export interface Event extends CustomEvent<Data> {
  type: EventName;
}

export default Event;
